<template>
    <v-container class="pa-5" fluid>
        <ReportShiftSummaryDialog
            :is-open="reportShiftSummaryDialog"
            :report-data="currentReportShiftSummary"
            :action-loading="actionLoading.approveReport"
            @on-save="updateReportShiftSummary"
            @on-close="closeReportShiftSummaryDialog"
        />
        <page-title>Zatwierdzanie raportów</page-title>

        <v-row>
            <v-col cols="12">
                <v-container fluid class="pa-0">
                    <v-row justify="end" dense>
                        <v-col cols="12" md="2">
                            <v-select
                                v-model="filters.group_id"
                                label="Dział"
                                :items="productionDepartments"
                                item-value="id"
                                item-text="name"
                                no-data-text="Nie znaleziono działu"
                                solo
                                hide-details
                                @change="changeGroup()"
                                @click:clear="clearFilter('group_id')"
                            />
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-select
                                v-model="filters.productionSiteGroup_ids"
                                label="Grupa stanowisk"
                                :items="productionSiteGroups"
                                item-value="id"
                                item-text="name"
                                no-data-text="Nie znaleziono grupy stanowisk"
                                solo
                                chips
                                multiple
                                @click:clear="clearFilter('productionSiteGroup_ids')"
                                @change="changeProductionSiteGroup()"
                            >   
                                <template #selection="data">
                                    <v-chip
                                        close
                                        @update:active="unselectProductionSiteGroupId(data)"
                                    >
                                        {{ data.item.name }}
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-select
                                v-model="filters.productionSite_id"
                                label="Stanowisko"
                                :items="productionSites"
                                item-value="id"
                                item-text="name"
                                no-data-text="Nie znaleziono stanowiska"
                                solo
                                hide-details
                                @change="changeFilter()"
                                @click:clear="clearFilter('productionSite_id')"
                            />
                        </v-col>
                        <v-col cols="12" md="4" lg="2">
                            <v-menu
                                v-model="menuFrom"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template #activator="{on}">
                                    <v-text-field
                                        v-model="filters.startDateTime__gte"
                                        label="Od"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        solo
                                        hide-details
                                        append-icon
                                        clearable
                                        class="mt-0"
                                        v-on="on"
                                        @input="changeFilter"
                                        @click:clear="clearFilter('startDateTime__gte')"
                                    >
                                        <template slot="append-outer">
                                            <div class="d-flex flex-wrap">
                                                <v-btn
                                                    icon
                                                    x-small
                                                    class="mt-n2"
                                                    data-sentry-label="Zmiana daty początku zakresu raportu"
                                                    @click="getForwardDate('startDateTime__gte')"
                                                >
                                                    <v-icon>
                                                        mdi-chevron-up
                                                    </v-icon>
                                                </v-btn>
                                                <v-btn
                                                    icon
                                                    x-small
                                                    data-sentry-label="Zmiana daty początku zarkesu raportu"
                                                    @click="getBackwardDate('startDateTime__gte')"
                                                >
                                                    <v-icon>
                                                        mdi-chevron-down
                                                    </v-icon>
                                                </v-btn>
                                            </div>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="filters.startDateTime__gte"
                                    first-day-of-week="1"
                                    @change="changeFilter"
                                    @input="menuFrom = false"
                                />
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="4" lg="2">
                            <v-menu
                                v-model="menuTo"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template #activator="{on}">
                                    <v-text-field
                                        v-model="filters.startDateTime__lte"
                                        label="Do"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        solo
                                        hide-details
                                        append-icon
                                        clearable
                                        class="mt-0"
                                        v-on="on"
                                        @input="changeFilter"
                                        @click:clear="clearFilter('startDateTime__lte')"
                                    >
                                        <template slot="append-outer">
                                            <div class="d-flex flex-wrap">
                                                <v-btn
                                                    icon
                                                    x-small
                                                    class="mt-n2"
                                                    data-sentry-label="Zmiana daty końca zakresu raportu"
                                                    @click="getForwardDate('startDateTime__lte')"
                                                >
                                                    <v-icon>
                                                        mdi-chevron-up
                                                    </v-icon>
                                                </v-btn>
                                                <v-btn
                                                    icon
                                                    x-small
                                                    data-sentry-label="Zmiana daty końca zakresu raportu"
                                                    @click="getBackwardDate('startDateTime__lte')"
                                                >
                                                    <v-icon>
                                                        mdi-chevron-down
                                                    </v-icon>
                                                </v-btn>
                                            </div>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="filters.startDateTime__lte"
                                    first-day-of-week="1"
                                    @change="changeFilter"
                                    @input="menuFrom = false"
                                />
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-select
                                v-model="filters.status_id"
                                label="Status"
                                :items="reportShiftSummaryStatuses"
                                item-value="id"
                                item-text="name"
                                no-data-text="Nie znaleziono statusu"
                                solo
                                clearable
                                hide-details
                                @change="changeFilter"
                            />
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-autocomplete
                                v-model="filters.supervisor_id"
                                :items="supervisors"
                                :filter="customUsersFilter"
                                :loading="supervisorsSearchLoading"
                                :search-input.sync="supervisorsSearch"
                                label="Przełożony"
                                class="v-text-field--placeholder-dark"
                                required
                                solo
                                hide-details
                                item-value="id"
                                no-data-text="Nie znaleziono"
                                clearable
                                @keyup.enter="changeFilter"
                                @input="changeFilter"
                                @click:clear="clearFilter('supervisor_id')"
                            >
                                <template slot="no-data">
                                    <v-list-item>
                                        <v-list-item-title>
                                            <template v-if="!supervisorsSearch">
                                                Wpisz treść aby odnaleźć <strong>przełożonego</strong>.
                                            </template>
                                            <template v-else-if="supervisorsSearchLoading">
                                                Trwa wyszukiwanie...
                                            </template>
                                            <template v-else>
                                                Nie znaleziono
                                            </template>
                                        </v-list-item-title>
                                    </v-list-item>
                                </template>
                                <template slot="selection" slot-scope="data">
                                    <template v-if="data.item.firstName && data.item.lastName">
                                        {{ data.item.firstName }} {{ data.item.lastName }}
                                    </template>
                                    <template v-else>
                                        {{ data.item.username }}
                                    </template>
                                </template>
                                <template slot="item" slot-scope="data">
                                    <template v-if="data.item.firstName && data.item.lastName">
                                        {{ data.item.firstName }} {{ data.item.lastName }}
                                    </template>
                                    <template v-else>
                                        {{ data.item.username }}
                                    </template>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-autocomplete
                                v-model="filters.user_id"
                                :items="users"
                                :filter="customUsersFilter"
                                :loading="usersSearchLoading"
                                :search-input.sync="usersSearch"
                                label="Użytkownik"
                                class="v-text-field--placeholder-dark"
                                required
                                solo
                                hide-details
                                item-value="id"
                                no-data-text="Nie znaleziono"
                                clearable
                                @keyup.enter="changeFilter"
                                @input="changeFilter"
                                @click:clear="clearFilter('user_id')"
                            >
                                <template slot="no-data">
                                    <v-list-item>
                                        <v-list-item-title>
                                            <template v-if="!usersSearch">
                                                Wpisz treść aby odnaleźć <strong>użytkownika</strong>.
                                            </template>
                                            <template v-else-if="usersSearchLoading">
                                                Trwa wyszukiwanie...
                                            </template>
                                            <template v-else>
                                                Nie znaleziono
                                            </template>
                                        </v-list-item-title>
                                    </v-list-item>
                                </template>
                                <template slot="selection" slot-scope="data">
                                    <template v-if="data.item.firstName && data.item.lastName">
                                        {{ data.item.firstName }} {{ data.item.lastName }}
                                    </template>
                                    <template v-else>
                                        {{ data.item.username }}
                                    </template>
                                </template>
                                <template slot="item" slot-scope="data">
                                    <template v-if="data.item.firstName && data.item.lastName">
                                        {{ data.item.firstName }} {{ data.item.lastName }}
                                    </template>
                                    <template v-else>
                                        {{ data.item.username }}
                                    </template>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
        <v-row justify="end" no-gutters>
            <v-col cols="auto">
                <v-btn
                    v-show="!isShipmentGroupSelected"
                    text
                    x-small
                    data-sentry-label="Generuj raport szczegółowy"
                    :disabled="actionLoading.generateDetailedReportsReport"
                    @click="generateReport(true)"
                >
                    <v-icon
                        v-if="!actionLoading.generateDetailedReportsReport"
                        small
                        color="green"
                    >
                        mdi-file-excel
                    </v-icon>
                    <v-progress-circular
                        v-else
                        indeterminate
                        color="primary"
                        class="mr-1"
                        size="12"
                        width="2"
                    />
                    Generuj raport szczegółowy
                </v-btn>
            </v-col>
            <v-col cols="auto">
                <v-btn
                    text
                    x-small
                    data-sentry-label="Generuj raport"
                    :disabled="actionLoading.generateReport"
                    @click="generateReport()"
                >
                    <v-icon
                        v-if="!actionLoading.generateReport"
                        small
                        color="green"
                    >
                        mdi-file-excel
                    </v-icon>
                    <v-progress-circular
                        v-else
                        indeterminate
                        color="primary"
                        class="mr-1"
                        size="12"
                        width="2"
                    />
                    Generuj raport
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="reportsShiftSummaries"
                        :loading="reportsShiftSummariesLoading"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :page.sync="pagination.page"
                        :items-per-page.sync="pagination.itemsPerPage"
                        :mobile-breakpoint="0"
                        :item-class="setSelectedRow"
                        name="reportsData"
                        @pagination="updatePagination"
                    >
                        <template #item.user="{item}">
                            <template v-if="item.user">
                                <template v-if="item.user.firstName && item.user.lastName">
                                    {{ item.user.firstName }} {{ item.user.lastName }}
                                </template>
                                <template v-else>
                                    {{ item.user.username }}
                                </template>
                            </template>
                            <template v-else>
                                -
                            </template>
                        </template>
                        <template #item.startDateTime="{item}">
                            {{ formatDate(item.startDateTime) }}
                        </template>
                        <template #item.endDateTime="{item}">
                            <template v-if="item.endDateTime">
                                {{ formatDate(item.endDateTime) }}
                            </template>
                            <template v-else>
                                -
                            </template>
                        </template>
                        <template #item.reportedAmount="{item}">
                            {{ item.reportedAmount }}
                        </template>
                        <template #item.finishedReports="{item}">
                            {{ item.finishedReports }}
                        </template>
                        <template #item.shippedBoxes="{item}">
                            {{ item.shippedBoxes }}
                        </template>
                        <template #item.shippedWeight="{item}">
                            {{ formatWeight(item.shippedWeight, false) }}
                        </template>
                        <template #item.totalReportedWeight="{item}">
                            {{ formatWeight(item.totalReportedWeight, false) }}
                        </template>
                        <template #item.workingTimeRatio="{item}">
                            <template v-if="item.workingTimeRatio">
                                <template v-if="item.workingTimeRatio.id === 10">
                                    <v-icon color="green">
                                        mdi-thumb-up-outline
                                    </v-icon>
                                </template>
                                <template v-else-if="item.workingTimeRatio.id === 20">
                                    <v-icon color="red">
                                        mdi-thumb-down-outline
                                    </v-icon>
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </template>
                            <template v-else>
                                -
                            </template>
                        </template>
                        <template #item.duration="{item}">
                            {{ parseDuration(item.duration) }}
                        </template>
                        <template #item.status="{item}">
                            {{ item.status.name }}
                        </template>
                        <template #item.approvalDateTime="{item}">
                            {{ formatDate(item.approvalDateTime) }}
                        </template>
                        <template #item.approvedBy="{item}">
                            <template v-if="item.approvedBy">
                                <template v-if="item.approvedBy.firstName && item.approvedBy.lastName">
                                    {{ item.approvedBy.firstName }} {{ item.approvedBy.lastName }}
                                </template>
                                <template v-else>
                                    {{ item.approvedBy.username }}
                                </template>
                            </template>
                            <template v-else>
                                -
                            </template>
                        </template>
                        <template #item.actions="{item}">
                            <div class="d-inline-flex align-center">
                                <v-btn
                                    color="success"
                                    x-small
                                    depressed
                                    :disabled="item.statusId == 20"
                                    data-sentry-label="Zatwierdzenie raportu"
                                    @click="filters.group_id === 14 ? updateReportShiftSummary(item) : showReportShiftSummaryDialog(item)"
                                >
                                    Zatwierdź
                                </v-btn>
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Szczegóły raportu"
                                            v-on="on"
                                            @click="openReportShiftSummary(item.id)"
                                        >
                                            <v-icon color="blue">
                                                mdi-ballot
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Szczegóły raportu</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { appConfig } from '@/config.js'
import router from '@/router'
import store from '@/store'

import PageTitle from '@/components/common/PageTitle'
import ReportShiftSummaryDialog from '@/components/common/ReportShiftSummaryDialog'

import customFilters from '@/mixins/customFilters'
import dataTableClassSetter from '@/mixins/dataTableClassSetter'
import dateFormatter from '@/mixins/dateFormatter'
import filters from '@/mixins/dataTableFilters'
import pagination from '@/mixins/dataTablePagination'
import parse from '@/mixins/parse.js'
import tooltipDelay from '@/mixins/tooltip'
import weightFormatter from '@/mixins/weightFormatter'

import { errorHandler, addSentryBreadcrumb } from '@/utils/errorHandler'

let searchTimer

export default {
    name: 'ReportsShiftSummaries',
    components: {
        PageTitle,
        ReportShiftSummaryDialog
    },
    mixins: [
        customFilters,
        dataTableClassSetter,
        dateFormatter,
        filters,
        pagination,
        parse,
        tooltipDelay,
        weightFormatter
    ],
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (!vm.filtersCleared) {
                store.dispatch('reports/clearReportsShiftSummaries')
            }
            vm.resetFiltersCleared()
        })
    },
    beforeRouteLeave(to, from, next) {
        if (!this.filtersCleared) {
            this.$store.dispatch('reports/clearReportsShiftSummariesFilters')
            this.clearSelectedListItemId()
        }
        next()
    },
    data() {
        return {
            reportShiftSummaryDialog: false,
            menuFrom: false,
            menuTo: false,
            supervisorsSearch: null,
            supervisorsSearchLoading: false,
            supervisors: [],
            usersSearch: null,
            usersSearchLoading: false,
            users: [],
            actionName: null,
            currentReportShiftSummary: null,
            actionLoading: {
                approveReport: false,
                generateReport: false,
                generateDetailedReportsReport: false,
            },
            headersStart: [
                {
                    text: 'Pracownik',
                    value: 'user',
                    width: 200,
                    sortable: false,
                },
                {
                    text: 'Start',
                    value: 'startDateTime',
                    sortable: false,
                    align: 'left',
                },
                {
                    text: 'Stop',
                    value: 'endDateTime',
                    sortable: false,
                    align: 'left',
                }
            ],
            headersEnd: [
                {
                    text: 'Sprawność',
                    value: 'workingTimeRatio',
                    sortable: false,
                    align: 'left',
                },
                {
                    text: 'Zaraportowano',
                    value: 'duration',
                    sortable: false,
                    align: 'left',
                },
                {
                    text: 'Data zatwierdzenia',
                    value: 'approvalDateTime',
                    sortable: false,
                    align: 'left',
                },
                {
                    text: 'Zatwierdzający',
                    value: 'approvedBy',
                    sortable: false,
                    align: 'left',
                },
                {
                    text: 'Status',
                    value: 'status',
                    sortable: false,
                    align: 'left',
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ],
            headersSendings: [
                {
                    text: 'Ilość kartonów',
                    value: 'reportedBoxes',
                    sortable: false,
                    align: 'left',
                },
                {
                    text: 'Waga sumaryczna',
                    value: 'totalReportedWeight',
                    sortable: false,
                    align: 'left',
                }
            ],
            headersReports: [
                {
                    text: 'Nakład',
                    value: 'reportedAmount',
                    sortable: false,
                    align: 'left',
                },
                {
                    text: 'Suma zadań',
                    value: 'finishedReports',
                    sortable: false,
                    align: 'left',
                },

            ]
        }
    },
    computed: {
        userId() {
            return this.$store.state.user.userId
        },
        productionSiteGroups() {
            return this.$store.state.configurations.productionSites.productionSiteGroups
        },
        productionSites() {
            return this.$store.state.configurations.productionSites.productionSites
        },
        selectedReportShiftSummaryId() {
            return this.$store.state.common.selectedListItemId
        },
        headers() {
            if (this.filters.group_id === 14) {
                return this.headersStart.concat(this.headersSendings).concat(this.headersEnd)
            }
            if (this.filters.group_id !== 14 && this.filters.group_id !== null) {
                return this.headersStart.concat(this.headersReports).concat(this.headersEnd)
            }

            return this.headersStart.concat(this.headersEnd)
        },
        reportsShiftSummaries() {
            return this.$store.state.reports.reports.reportsShiftSummaries
        },
        reportsShiftSummariesLoading() {
            return this.$store.state.reports.reports.reportsShiftSummariesLoading
        },
        savedFilters() {
            return this.$store.state.reports.reports.reportsShiftSummariesFilters
        },
        productionDepartments() {
            return this.$store.state.administration.users.productionDepartments
        },
        reportShiftSummaryStatuses() {
            return this.$store.state.reports.reports.reportShiftSummaryStatuses
        },
        generalGroups() {
            return appConfig.reports.generalGroups
        },
        isGroupSelected() {
            return typeof this.filters.group_id !== 'undefined' && this.filters.group_id !== null
        },
        isShipmentGroupSelected() {
            return this.filters.group_id == 14 // shipement group id
        },
        filterQuery() {
            const filters = Object.assign({}, this.filters)
            let query = ''
            const startDateTime__gte = filters['startDateTime__gte']
            const startDateTime__lte = filters['startDateTime__lte']

            for (let item in filters) {
                if (
                    filters[item] !== null &&
                    typeof filters[item] !== 'undefined' ||
                    (Array.isArray(filters[item]) && filters[item].length > 0)
                ) {
                    if (item == 'productionSiteGroup_ids') {
                        if (filters['productionSiteGroup_ids'].length === 0) {
                            continue
                        }
                    }
                    if (item == 'startDateTime__gte') {
                        filters['startDateTime__gte'] = `${startDateTime__gte}T00:00:00Z`
                    }
                    if (item == 'startDateTime__lte') {
                        filters['startDateTime__lte'] = `${startDateTime__lte}T23:59:59Z`
                    }
                    if (item == 'user_id' && filters[item] == null) {
                        filters[item] = 0 // not existing user
                    }
                    if (item !== 'group_id') {
                        query = query.concat('&', `${item}=${filters[item]}`)
                    }
                }
            }

            return query
        }
    },
    watch: {
        usersSearch(value = null) {
            if (value === null) return

            this.usersSearchLoading = true

            clearTimeout(searchTimer)

            searchTimer = setTimeout(() => {
                if (value) {
                    this.searchUsers(value)
                } else {
                    this.usersSearchLoading = false
                    this.users = []
                }
            }, 500)
        },
        supervisorsSearch(value = null) {
            if (value === null) return

            this.supervisorsSearchLoading = true

            clearTimeout(searchTimer)

            searchTimer = setTimeout(() => {
                if (value) {
                    this.searchSupervisors(value)
                } else {
                    this.supervisorsSearchLoading = false
                    this.supervisors = []
                }
            }, 500)
        }
    },
    beforeMount() {
        if (!this.savedPagination.pagination) {
            this.resetPagination()
        }
    },
    mounted() {
        this.getUser()
        this.getShipmentsReportsShiftSummaryStatuses()
        this.getProductionDepartments()
        this.getReportsShiftSummaries()
    },
    methods: {
        getUser() {
            this.$store.dispatch('administration/getUser', this.userId )
                .then(response => {
                    this.user = response.data
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        generateReport(detailedReport=false) {
            let query = this.filterQuery
            let functionName = ''

            if (detailedReport) {
                query = 'detailedReport=true'.concat(query)
                this.actionLoading.generateDetailedReportsReport = true
            } else {
                query += 'report=true'.concat(query)
                this.actionLoading.generateReport = true
            }

            if (this.isShipmentGroupSelected) {
                functionName = 'generateShipmentReportShiftSummariesReport'
            } else {
                functionName = 'generateReportShiftSummariesReport'
            }
            this.$store.dispatch(`reports/${functionName}`, {
                query: query,
                userEmail: this.user.email
            })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    if (detailedReport) {
                        this.actionLoading.generateDetailedReportsReport = false
                    } else {
                        this.actionLoading.generateReport = false
                    }
                })
        },
        getProductionSitesGroups() {
            this.$store.dispatch('configurations/getProductionSitesGroups', {
                query: `?productionDepartment_id=${this.filters.group_id}`
            })
                .catch(error => {
                    errorHandler(error)
                })
        },
        getProductionSites() {
            if (this.filters.productionSiteGroup_ids.length > 0) {
                this.$store.dispatch('configurations/getProductionSites', {
                    query: `?group_ids=${this.filters.productionSiteGroup_ids}`
                })
                    .catch(error => {
                        errorHandler(error)
                    })
            }

        },
        setSelectedRow(item) {
            if (item.id === this.selectedReportShiftSummaryId) {
                return 'isSelected'
            }
        },
        searchUsers(query = '') {
            addSentryBreadcrumb('ui.action', 'Wyszukiwanie użytkownika')

            this.$store.dispatch('administration/findUsers', {
                paginate: '?limit=20',
                query: query
            })
                .then(response => {
                    this.users = response.data.results
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.usersSearchLoading = false
                })
        },
        searchSupervisors(search = '') {
            addSentryBreadcrumb('ui.action', 'Wyszukiwanie przełożonego')

            this.$store.dispatch('administration/receiveUsers', {
                paginate: '?limit=20',
                query: '&mayHaveSubordinate=true',
                search
            })
                .then(response => {
                    this.supervisors = response.data.results
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.supervisorsSearchLoading = false
                })
        },
        getBackwardDate(startDateTime) {
            if (Date.parse(this.filters[startDateTime])) {
                this.filters[startDateTime] = this.getDayBackward(this.filters[startDateTime])
                this.changeFilter()
            }
        },
        getForwardDate(startDateTime) {
            if (Date.parse(this.filters[startDateTime])) {
                this.filters[startDateTime] = this.getDayForward(this.filters[startDateTime])
                this.changeFilter()
            }
        },
        getShipmentsReportsShiftSummaryStatuses() {
            this.$store.dispatch('reports/getShipmentsReportsShiftSummaryStatuses')
                .catch(error => {
                    errorHandler(error)
                })
        },
        getProductionDepartments() {
            this.$store.dispatch('administration/getProductionDepartments', {
                query: '?showInReporting=true'
            })
                .catch(error => {
                    errorHandler(error)
                })
        },
        getReportsShiftSummaries() {
            if (this.filters.group_id === 14) {
                this.actionName = 'updateShipmentReportShiftSummary'
                this.$store.dispatch('reports/getShipmentsReportsShiftSummaries', {
                    paginate: this.paginate(),
                    query: this.filterQuery
                })
                    .then(response => {
                        this.handlePaginationResponse(response)
                    })
                    .catch(error => {
                        errorHandler(error)
                    })
            }
            if (this.filters.group_id !== 14 && this.filters.group_id !== null) {
                this.actionName = 'updateReportShiftSummary'
                this.$store.dispatch('reports/getReportsShiftSummaries', {
                    paginate: this.paginate(),
                    query: this.filterQuery
                })
                    .then(response => {
                        this.handlePaginationResponse(response)
                    })
                    .catch(error => {
                        errorHandler(error)
                    })
            }
        },
        openReportShiftSummary(reportId) {
            this.savePagination(this.$options.name)
            this.saveFiltersCleared()
            this.setSelectedListItemId(reportId)
            const routerName = this.filters.group_id !== 14
                ? 'reportsReportsShiftSummariesDetailedReports'
                : 'reportsShipmentsReportsShiftSummariesDetailedShipmentsReports'

            router.push({
                name: routerName,
                params: {
                    id: reportId,
                }
            })
                .catch(error => {
                    errorHandler(error)
                })
        },
        updateReportShiftSummary(reportShiftSummary) {
            this.actionLoading.approveReport = true

            this.$store.dispatch(`reports/${this.actionName}`, {
                ...reportShiftSummary,
                statusId: 20 //Zatwierdzony
            })
                .then(() => {
                    this.getReportsShiftSummaries()
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.approveReport = false
                    this.closeReportShiftSummaryDialog()
                })
        },
        showReportShiftSummaryDialog(reportShiftSummary) {

            this.$store.dispatch('toggleMainLoader', true)

            this.$store.dispatch('reports/getDetailedReports', {
                reportShiftSummary_id: reportShiftSummary.id
            })
                .then(response => {
                    this.currentReportShiftSummary = {
                        ...reportShiftSummary,
                        detailedReports: response.data.results
                    }
                    this.reportShiftSummaryDialog = true
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.$store.dispatch('toggleMainLoader', false)
                })
        },
        closeReportShiftSummaryDialog() {
            this.reportShiftSummaryDialog = false
            this.currentReportShiftSummary = null
        },
        changeProductionSiteGroup() {
            this.$store.state.configurations.productionSites.productionSites = []
            this.clearFilter('productionSite_id')
            this.getProductionSites()
        },
        changeGroup() {
            this.clearFilter('productionSite_id')
            this.getProductionSitesGroups()
        },
        changeFilter() {
            this.$store.dispatch('reports/setReportsShiftSummariesFilters', this.filters)
                .catch(error => {
                    errorHandler(error)
                })
            this.resetPagination()
        
            if (this.isGroupSelected) this.getReportsShiftSummaries()

        },
        updatePagination(pagination) {
            this.pagination = pagination
            this.evaluateSavedPagination(this.$options.name)

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending && this.isGroupSelected && !this.savedPagination.pagination) {
                this.getReportsShiftSummaries()
            }
            this.clearPaginationPending()
        },
        unselectProductionSiteGroupId(item) {
            this.$store.state.configurations.productionSites.productionSites = []
            this.filters.productionSiteGroup_ids.splice(item.index, 1)
            this.clearFilter('productionSite_id')
            this.getProductionSites()
        }
    },
}

</script>